"use strict";import{html as d}from"@cisco-u/base";export function linkedinIcon({height:l=16,width:e=16,hidden:r=!1,title:o="LinkedIn",type:t="",hover:i=!1}={}){return t==="dark"?d`<svg
      width=${e}
      height=${l}
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="${r?"true":"false"}"
      aria-label="${o}"
      role="img"
      style=${i?"color: var(--color-blue-primary);":"color: var(--color-white);"}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.9989 15.9997C31.9989 24.8366 24.8357 32 15.9994 32C7.16259 32 0 24.8366 0 15.9997C0 7.16373 7.16259 0 15.9994 0C24.8357 0 31.9989 7.16373 31.9989 15.9997Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 15.1846V24H12V12H8V15.1846Z"
        fill="#1B1C1D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0001 6C8.89558 6 8 6.89569 8 8.00013C8 9.10483 8.89558 10 10.0001 10C11.1047 10 12 9.10483 12 8.00013C12 6.89569 11.1047 6 10.0001 6Z"
        fill="#1B1C1D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.9113 15.6845C24.6367 13.4228 23.6345 12 20.6838 12C18.9337 12 17.7585 12.6738 17.2779 13.6194H17.2279V12H14V24H17.3739V18.0524C17.3739 16.4837 17.66 14.9654 19.5318 14.9654C21.3766 14.9654 21.525 16.7584 21.525 18.1535V24H24.9995V17.4057H25C25 16.7907 24.9754 16.2146 24.9113 15.6845Z"
        fill="#1B1C1D"
      />
    </svg>`:d`<svg
    width=${e}
    height=${l}
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${r?"true":"false"}"
    aria-label="${o}"
    role="img"
    style=${i?"color: var(--color-blue-primary);":"color: var(--color-gray-100);"}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.9989 15.9997C31.9989 24.8366 24.8357 32 15.9994 32C7.16259 32 0 24.8366 0 15.9997C0 7.16373 7.16259 0 15.9994 0C24.8357 0 31.9989 7.16373 31.9989 15.9997Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 15.1846V24H12V12H8V15.1846Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 6C8.89558 6 8 6.89569 8 8.00013C8 9.10483 8.89558 10 10.0001 10C11.1047 10 12 9.10483 12 8.00013C12 6.89569 11.1047 6 10.0001 6Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.9113 15.6845C24.6367 13.4228 23.6345 12 20.6838 12C18.9337 12 17.7585 12.6738 17.2779 13.6194H17.2279V12H14V24H17.3739V18.0524C17.3739 16.4837 17.66 14.9654 19.5318 14.9654C21.3766 14.9654 21.525 16.7584 21.525 18.1535V24H24.9995V17.4057H25C25 16.7907 24.9754 16.2146 24.9113 15.6845Z"
      fill="white"
    />
  </svg>`}
//# sourceMappingURL=linkedin.js.map
